<script>
export default {
    name: "Bids",
    props: ['bids', 'currency']
}
</script>

<template>


        <div class="bg-white" v-if="bids.length > 0">
            <div class="overflow-hidden border-t border-gray-100">
                <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
                        <table class="w-full text-left">
                            <thead class="sr-only">
                            <tr>
                                <th>Amount</th>
                                <th class="hidden sm:table-cell">Client</th>
                                <th>More details</th>
                            </tr>

                            </thead>
                            <tbody>
                            <tr class="text-sm leading-6 text-gray-900">
                                <th class="relative isolate py-2 font-semibold">
                                    Bid Amount
                                    <div
                                        class="absolute inset-y-0 right-full -z-10 w-screen border-b border-gray-200 bg-gray-50">
                                    </div>
                                    <div
                                        class="absolute inset-y-0 left-0 -z-10 w-screen border-b border-gray-200 bg-gray-50">
                                    </div>
                                </th>
                                <th class="relative isolate py-2 font-semibold">
                                    Bid Time
                                </th>
                            </tr>
                            <bid-row v-for="bid in bids" :bid="bid" :currency="currency"></bid-row>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
</template>

<style scoped>

</style>
